// 线上地址 废弃
// const baseURL = 'https://thermo-minisite.synconize.com/minisite'
// 线上地址 新
const baseURL = 'https://minisite-sdg.thermofisher.cn/minisite'
// 测试地址
// const baseURL = 'http://minisite-test.wrbt.synconize.com/test/'

// 线下地址
// const baseURL = 'http://106.14.218.186:7793/';

export default baseURL;
